export const LessonProgressType = Object.freeze({
  notStarted: 0,
  started: 1,
  InProgress: 2,
  completed: 3,
});

export const LessonProgressTypeLabel = Object.freeze({
  [LessonProgressType.notStarted]: 'Not Started',
  [LessonProgressType.started]: 'Started',
  [LessonProgressType.InProgress]: 'In Progress',
  [LessonProgressType.completed]: 'Completed',
});
